<template>
  <div
    class="fixed z-10 inset-0 overflow-y-auto overflow-x-auto"
    v-show="state"
  >
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      ---- {{ user_collection }}---
      <transition
        enter-active-class="transition ease-out duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="transition ease-in duration-200"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div class="fixed inset-0 transition-opacity" v-show="state">
          <div class="absolute inset-0 bg-gray-900 opacity-75"></div>
        </div>
      </transition>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span
      >&#8203;
      <transition
        enter-active-class="transition ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="transition ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <div
          class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
          v-show="state"
        >
          <label class="inline-block text-sm text-gray-600" for="Multiselect"
            >Select multiple roles</label
          >
          <div class="relative flex w-full">
            <select
              id="select-role"
              name="roles[]"
              multiple
              placeholder="Select roles..."
              autocomplete="off"
              class="block w-full rounded-sm cursor-pointer focus:outline-none"
            >
              <option value="1">super admin</option>
              <option value="2">admin</option>
              <option value="3">writer</option>
              <option value="4">user</option>
            </select>
          </div>

          <div class="grid grid-cols-6">
            <div class="col-span-6">
              hhhhh{{ id }}
              <a-form-item label="Collections">
                <a-select
                  mode="multiple"
                  placeholder="Select a collection"
                  option-filter-prop="children"
                  v-model:value="user_collection"
                >
                  <a-select-option
                    :value="item.id"
                    v-for="item in collections"
                    :key="item.id"
                  >
                    {{ item.title }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </div>

          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                @click="onDelete"
              >
                Yes
              </button>
            </span>
            <span
              class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto"
            >
              <button
                type="button"
                class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                @click="state = false"
              >
                Cancel
              </button>
            </span>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed, onMounted } from "vue";
import { useRouter } from "vue-router";
// import Icon from "@/components/UI/Icon";

export default {
  components: {},
  props: {
    isVisible: Boolean,
    id: String,
  },
  setup(props, { emit }) {
    onMounted(async () => {
      await store.dispatch("GET_COLLECTIONS");
    });

    const collections = computed(() => store.state.collections);
    const user_collections = computed(() => store.state.user);

    const store = useStore();
    const router = useRouter();

    const state = computed({
      get: () => props.isVisible,
      set: (newValue) => emit("update:isVisible", newValue),
    });

    const onDelete = async () => {
      const id = props.id;
      const response = await store.dispatch("DELETE_ADVERTISMENT", id);
      if (response) {
        router.push("/advertisements");
      }
    };

    return { state, onDelete, collections, user_collections };
  },
};
</script>

<style></style>
